import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { POSTS } from "./posts";
import BlogCover from "./BlogCover";

export default function Blog() {
  const preview = POSTS.slice(0, 6);
  return (
    <section id="blog" data-testid="blog-section" className="py-14 md:py-20 bg-paper">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex items-center gap-4 mb-8 md:mb-12">
          <span className="font-mono text-[11px] uppercase tracking-[0.22em] text-signal">§ 05 — Writing</span>
          <span className="flex-1 h-px bg-line" />
          <span className="font-mono text-[11px] uppercase tracking-[0.22em] text-ink2">Latest essays</span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 mb-10 md:mb-12 items-end">
          <h2 className="md:col-span-8 font-heading font-black text-5xl md:text-7xl leading-[0.9] tracking-tightest">
            Notes from the <span className="text-signal">frontline</span>.
          </h2>
          <Link
            to="/blog"
            data-testid="view-all-blog"
            className="md:col-span-4 md:justify-self-end inline-flex items-center gap-2 border border-ink bg-paper hover:bg-ink hover:text-paper px-6 py-4 font-heading font-bold text-[12px] uppercase tracking-[0.2em] transition-colors"
          >
            View the full journal <ArrowUpRight size={14} />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
          {preview.map((p, i) => (
            <motion.div
              key={p.slug}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.08 }}
              className="blog-card group flex flex-col"
            >
              <Link
                to={`/blog/${p.slug}`}
                data-testid={`blog-card-${i}`}
                className="flex flex-col"
              >
                <div className="relative aspect-[16/10] overflow-hidden border border-ink">
                  <BlogCover post={{ ...p, index: i }} compact />
                </div>
                <div className="pt-6 flex-1 flex flex-col">
                  <h3 className="font-heading font-bold text-2xl md:text-[26px] leading-[1.15] tracking-tight group-hover:text-signal transition-colors">
                    {p.title}
                  </h3>
                  <p className="mt-4 text-[15px] leading-relaxed text-ink2">{p.excerpt}</p>
                  <div className="mt-6 flex items-center justify-between border-t border-line pt-4">
                    <span className="font-mono text-[11px] uppercase tracking-[0.22em] text-ink2">
                      {p.date}
                    </span>
                    <span className="inline-flex items-center gap-1 font-mono text-[11px] uppercase tracking-[0.22em] group-hover:text-signal">
                      Read <ArrowUpRight size={14} />
                    </span>
                  </div>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
